export default function WrapUpPageList({ heading, listitem }) {
  return (
    <div className="flex gap-3  flex-wrap">
      <div className="bg-[#015A52] text-white p-2 text-base sm:text-xl rounded-xl h-fit ">
        {heading}
      </div>
      <div className="flex flex-col gap-2">
        {listitem?.map((item, index) => (
          <div key={index} className="bg-[#F1F1F1] p-2 rounded-lg">
            {' '}
            {item?.icd_code || item?.code} - {item?.description}
          </div>
        ))}
      </div>
    </div>
  );
}
